var staticStrUndefined = require('./staticStrUndefined')

/* eslint-disable valid-typeof */
var staticLocation = typeof location === staticStrUndefined ? 0 : location

module.exports = staticLocation



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticLocation.js
// module id = 217
// module chunks = 75